export default function TourCategory({ containerSelector = '' }) {
  const TOOLTIP_SELECTOR = '.scout-element__tour-category__tooltip';
  const CONTAINER_SELECTOR = '.js-scout-element__tour-category-tooltip-container';

  if (document.querySelector(`${containerSelector} ${CONTAINER_SELECTOR}`)) {
    $(containerSelector)
      .on('mouseenter', CONTAINER_SELECTOR, (e) => {
        if (window.innerWidth < 768) return;
        $(e.target).parent().find(TOOLTIP_SELECTOR).removeClass('hid');
      })
      .on('mouseleave', CONTAINER_SELECTOR, (e) => $(e.target).parent().find(TOOLTIP_SELECTOR).addClass('hid'));
  }
}
